import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { getGlobalClasses } from '../themes';

import AuthUserContainer from '../containers/AuthUser';
import RecentShifts from '../components/timeClock/recentShifts';
import PunchIn from '../components/timeClock/clockInAndOut';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
	};
};

class ClockInAndOut extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		const { authUser } = this.props;

		let isDriver = authUser.role === 'driver';
		return (
			<>
				<PunchIn showPrintDeliveryTickets={isDriver} userId={authUser.userId} />
				<RecentShifts />
			</>
		);
	}
}

ClockInAndOut.propTypes = {
	authUser: PropTypes.object,
};

export default _.flow([withStyles(styles), AuthUserContainer])(ClockInAndOut);
